import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Calendar, Loader2, AlertCircle } from 'lucide-react';
import { completeGoogleCalendarCallback } from './services/googleCalendar.service.ts';

const GoogleCalendarCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const err = searchParams.get('error');

    if (err) {
      setError('Google Takvim bağlantısı iptal edildi.');
      return;
    }

    const savedState = sessionStorage.getItem('tbkmeet_gcal_oauth_state');
    if (!code || !state || !savedState || state !== savedState) {
      setError('Geçersiz OAuth yanıtı. Lütfen tekrar deneyin.');
      return;
    }

    sessionStorage.removeItem('tbkmeet_gcal_oauth_state');

    (async () => {
      try {
        await completeGoogleCalendarCallback(code, state);
        navigate('/calendar', { replace: true });
      } catch (e: unknown) {
        const msg =
          e && typeof e === 'object' && 'response' in e
            ? (e as { response?: { data?: { error?: string } } }).response?.data?.error
            : undefined;
        setError(msg || 'Google Takvim bağlantısı tamamlanamadı.');
      }
    })();
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-slate-800/50 border border-white/10 rounded-xl p-8 text-center">
          <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
          <p className="text-white mb-4">{error}</p>
          <Link
            to="/calendar"
            className="inline-flex items-center gap-2 text-purple-300 hover:text-purple-200"
          >
            <Calendar className="w-4 h-4" />
            Takvime dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <div className="flex items-center gap-3 text-gray-400">
        <Loader2 className="w-5 h-5 animate-spin" />
        Google Takvim bağlanıyor...
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;
